function getElementPosition( el ){
    let rect = el.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
}

export function scrollToElement( selector = 'body' ){
    let scrollTo = 0;
    if( selector !== 'body' ){
        let element = document.querySelector( selector );
        if( element ){
            scrollTo = getElementPosition( element );
        }
    }
    window.scroll({ top: scrollTo, left: 0, behavior: 'smooth' });
}